'use client';
import * as React from 'react';
import { createPreset } from '../createPreset';
import { body1StrongerClassNames, useBody1StrongerStyles } from './useBody1StrongerStyles.styles';
/**
 * Text preset component for the Body1Stronger typography variant
 */ export const Body1Stronger = createPreset({
    useStyles: useBody1StrongerStyles,
    className: body1StrongerClassNames.root,
    displayName: 'Body1Stronger'
});
